// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ImpactNavButton-cls1___d5273509e33f69e256d{/*!*/}.ImpactNavButton-cls2___bf4171ad5c3a542b96d{position:absolute;top:0;right:-3px;width:10px;height:10px;border-radius:50%;background-color:#05b01c}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "ImpactNavButton-cls1___d5273509e33f69e256d",
	"cls2": "ImpactNavButton-cls2___bf4171ad5c3a542b96d ImpactNavButton-cls1___d5273509e33f69e256d"
};
export default ___CSS_LOADER_EXPORT___;
